<template>
  <div class="allpage" :class="{'flex0': !show}">
    <div class="messageArea" v-if="show">
      <div class="messageArea-header">
        <span class="bold">消息区</span>
        <span>
          <span v-if="aggregation === 0 && !tableLoading" @click="showModel" class="history-text cursor">满桩值设置</span>
          <span @click="toggleStatistical =!toggleStatistical" style="vertical-align: top;">
            <i class="iconfont icon cursor">&#xe68b;</i>
          </span>
        </span>
      </div>
      <div v-show="toggleStatistical">
        <ul class="content" v-if="siteMessage && siteMessage.length">
          <li v-for="(item,index) in siteMessage" :key="'sm'+index">
            <span class="t">{{item.createTime | dateFormat('yyyy-MM-dd hh:mm:ss')}}</span>
            <span class="ad cut">{{item.siteName}}</span>
            <span class="num">{{item.num}}辆</span>
            <span
              class="st"
              :class="{
                'blue': getSiteStatusNew(item.messageType)&&getSiteStatusNew(item.messageType).style === 0,
                'warning': getSiteStatusNew(item.messageType)&&getSiteStatusNew(item.messageType).style === 1,
                'red': getSiteStatusNew(item.messageType)&&getSiteStatusNew(item.messageType).style === 2,
                'origin': getSiteStatusNew(item.messageType)&&getSiteStatusNew(item.messageType).style === 3,
              }">
              {{getSiteStatusNew(item.messageType)&&getSiteStatusNew(item.messageType).status}}
            </span>
            <span class="btn blue cursor" @click="showModelDetail(item)">详情</span>
          </li>
        </ul>
        <div v-else style="margin: 15px 0 60px 0;">
          暂无信息
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    siteMessage: {
      type: Array,
      default() {
        return []
      }
    },
    show: {
      type: Boolean,
      default: true
    },
    aggregation: {
      type: Number
    },
    tableLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      toggleStatistical: true
    }
  },
  methods: {
    showModelDetail(item) {
      const data = {
        ...item,
        type: 4
      }
      this.$emit('showModel', data)
    },
    showModel() {
      const data = {
        type: 3
      }
      this.$emit('showModel', data)
    },
    getSiteStatusNew(messageType) {
      return {
        empty: {
          style: 0,
          status: '空桩'
        },
        less: {
          style: 1,
          status: '偏少'
        },
        more: {
          style: 3,
          status: '偏多'
        },
        full: {
          style: 2,
          status: '满桩'
        }
      }[messageType]
    }
  }
}
</script>

<style lang="less" scoped>
.allpage.flex0 {
  flex: none;
}
.allpage {
  flex: 1;
  margin-left: 4px;
  background-color: #FFF;
  .messageArea {
    padding: 0 16px;
    .messageArea-header {
      height: 42px;
      line-height: 42px;
      display: flex;
      justify-content: space-between;
      font-size:14px;
      font-family:PingFangSC-Medium,PingFang SC;
      color:rgba(111,117,128,1);
      border-bottom: 1px solid #EBEBEB;
      .bold {
        font-weight: bold;
      }
      .icon {
        font-size: 18px;
        color: #999;
      }
      .history-text {
        font-size:12px;
        color: #1F8FFB;
        margin-right: 30px;
      }
    }
    .content {
      padding: 22px 0 23px 0;
      li {
        display: flex;
        padding: 6px 0;
        span {
          font-size:12px;
          font-family:PingFangSC-Regular,PingFang SC;
          color: #000;
        }
        span.t {
          display: inline-block;
          width: 35%;
        }
        span.ad {
          display: inline-block;
          width: 40%;
          padding-right: 12px;
        }
        span.num {
          display: inline-block;
          width: 10%;
        }
        span.st {
          display: inline-block;
          width: 10%;
        }
        span.btn {
          display: inline-block;
          width: 10%;
          text-align: right;
        }
      }
    }
  }
}
</style>
